import { ProcessUebergabeStepType } from '@dpa/common/dist/prismaGenerated/inputTypeSchemas/ProcessUebergabeStepSchema'

type StateLike = {
  state: string
}

export const uebergabeRouteSegments: Record<ProcessUebergabeStepType, string> = {
  Vertrieb2PE: 'vertrieb2pe',
  PE2Vertrieb: 'pe2vertrieb',
  Vertrieb2ENG: 'vertrieb2eng',
  ENG2Vertrieb: 'eng2vertrieb',
  CompletionOfPlanning: 'completionofplanning',
  CompletionOfPlanning2Vertrieb: 'completionofplanning',
  Vertrieb2Projektleitung: 'vertrieb2projektleitung',
  Projektleitung2SuW: 'projektleitung2suw',
  SuW2Running: 'suw2running',
  preliminaryHandover_Projektleitung2SuW: 'preliminaryhandover_projektleitung2suw',
  finalHandover_Projektleitung2SuW: 'finalhandover_projektleitung2suw',
}

export function getUebergabeRouteSegment(step: ProcessUebergabeStepType) {
  return uebergabeRouteSegments[step]
}

export function isWarrantyBranch(stateHistory: Array<StateLike> | undefined) {
  return (
    stateHistory?.some(({ state }) =>
      [
        'workOn_Projektleitung2SuW_withoutContract',
        'handover_GewaehrleistungsUebergabe',
        'workOn_Fremdbetrieb',
        'handover_terminated_inFremdbetrieb',
        'terminated_inFremdbetrieb',
      ].includes(state),
    ) ?? false
  )
}

export function getUebergabeTabTitleKey(
  step: ProcessUebergabeStepType,
  stateHistory: Array<StateLike> | undefined,
) {
  if (step === 'SuW2Running' && isWarrantyBranch(stateHistory)) {
    return 'tabTitle_SuW2Running_warranty'
  }

  return `tabTitle_${step}`
}

export function getUebergabeTitleKey(
  step: ProcessUebergabeStepType,
  stateHistory: Array<StateLike> | undefined,
) {
  if (step === 'SuW2Running' && isWarrantyBranch(stateHistory)) {
    return 'uebergabeTitle_SuW2Running_warranty'
  }

  return `uebergabeTitle_${step}`
}
